import { useEffect, useRef } from 'react'

export default function useInitialMatchEdit({
  initialEditMatchId,
  matches,
  loading,
  onOpenEdit,
  onInitialEditHandled,
}) {
  const handledIdRef = useRef(null)

  useEffect(() => {
    if (!initialEditMatchId) {
      handledIdRef.current = null
      return
    }

    if (loading || handledIdRef.current === initialEditMatchId) return

    const match = matches.find((item) => String(item.id) === String(initialEditMatchId))
    if (!match) return

    handledIdRef.current = initialEditMatchId
    onOpenEdit(match)
    onInitialEditHandled?.()
  }, [initialEditMatchId, loading, matches, onOpenEdit, onInitialEditHandled])
}
